import {classNames} from '../../util/css';
import {getFormattedVideoDuration} from '../../util/time';

import * as styles from './video-duration-tag.scss';

type PropsType = {
    durationMillis: number;
    rightBottomCorned?: boolean;
};

export function VideoDurationTag(props: PropsType): JSX.Element {
    const {durationMillis, rightBottomCorned = true} = props;

    return (
        <div
            className={classNames(styles.VideoDurationTag, {
                [styles.VideoDurationTag__rightBottomCorner]: rightBottomCorned,
            })}
        >
            {getFormattedVideoDuration(durationMillis)}
        </div>
    );
}
